import { FigureShopify } from '@studiometa/ui';

/**
 *
 */
export default class Figure extends FigureShopify {
  static config = {
    name: 'Figure',
  };
}
